import { Partner } from 'types';

export const isActivePartner = (partner: Partner): boolean => {
  const { actual = 0, future = 0, drafts = 0 } = partner?.sharesCount || {};

  const { coOwnerPrimary = 0, coOwnerSecondary = 0 } =
    partner?.sharesBurdenCount || {};

  const totalShares =
    actual + future + drafts + coOwnerPrimary + coOwnerSecondary;

  const hasNoShares = totalShares === 0;
  const hasIncorporationDate = !!partner?.incorporationDate;

  if (hasNoShares && hasIncorporationDate) {
    return false;
  }

  return true;
};
